/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateApiKeyResponse
 */
export interface CreateApiKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateApiKeyResponse
     */
    data?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateApiKeyResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateApiKeyResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateApiKeyResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof CreateApiKeyResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the CreateApiKeyResponse interface.
 */
export function instanceOfCreateApiKeyResponse(value: object): boolean {
    return true;
}

export function CreateApiKeyResponseFromJSON(json: any): CreateApiKeyResponse {
    return CreateApiKeyResponseFromJSONTyped(json, false);
}

export function CreateApiKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateApiKeyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : json['data'],
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CreateApiKeyResponseToJSON(value?: CreateApiKeyResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'],
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

